/**
 * NOTE: Need to add new country manually as we need to create a new table for each country
 * in the database to store articles related to that country.
 */
import { Category } from '@/types/category';
import { Country } from '@/types/country';
import { Topic } from '@/types/topic';
import { Tag } from '@/types/tag';
import apiClient from '@/utils/api';

// API endpoints for admin functionalities
export const adminApi = {
  getAllCategories: async () => {
    const response = await apiClient.get('/admin/categories');
    return response.data.data;
  },
  getAllTopics: async () => {
    const response = await apiClient.get('/admin/topics');
    return response.data.data;
  },
  getAllTopicsAsCategories: async () => {
    const topics = await adminApi.getAllTopics();
    // Map topics to the same format as categories for easier use in dropdowns
    return topics.map(
      (topic: { topicCode: string; topicNameEN: string; topicNameVI?: string }) => ({
        categoryCode: topic.topicCode,
        categoryNameEN: topic.topicNameEN,
        categoryNameVI: topic.topicNameVI || topic.topicNameEN,
      })
    );
  },
  getAllCountries: async () => {
    const response = await apiClient.get('/admin/countries');
    return response.data.data;
  },
  getAllTags: async () => {
    const response = await apiClient.get('/admin/tags');
    return response.data.data;
  },
  getAllCategoriesByCountry: async (countryCode: string) => {
    const response = await apiClient.get(`/admin/${countryCode}/categories/`);
    return response.data.data;
  },
  addCountry: async (countryData: Country) => {
    const response = await apiClient.post('/admin/countries', countryData);
    return response.data;
  },
  addCategory: async (categoryData: Category) => {
    const response = await apiClient.post('/admin/categories', categoryData);
    return response.data;
  },
  addTopic: async (topicData: Topic) => {
    const response = await apiClient.post('/admin/topics', topicData);
    return response.data;
  },
  addTag: async (tagData: Tag) => {
    const response = await apiClient.post('/admin/tags', tagData);
    return response.data;
  },
};
